import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GetSentimentResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GetSentimentResponseDataSchema>>

export const CustomerSentimentQuery = (customerId: string) => {
  return queryOptions({
    queryKey: ["sentiment", customerId],
    queryFn: async () => {
      const response = await axios.get<Response>(`/insights/sentiment/${customerId}`)
      return response.data.data
    },
  })
}
